import { useEffect, useRef } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { UseExampleEventLabels, UseExampleEvents } from 'builder/modules/constants'
import Spinner from 'builder/components/Spinner'
import cardPlaceholder from 'images/builder/panel/document/placeholder.svg'
import {
  LoaderContainer,
  ExamplesContainer,
  ResumeCard,
  ResumeTitle,
  ResumeImg,
  ViewIcon,
} from '../styles'
import { useResumeExampleContext } from '../ResumeExampleContext'
import view from './view.png'

const ResumeExamples = () => {
  const { resumeExamples, setSelectedResumeExample, fetchingResumeExamples, currentPage } =
    useResumeExampleContext()
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    trackInternalEvent(UseExampleEvents.seeExamplesLibrary, {
      label: UseExampleEventLabels.examplesPrefill,
    })
  }, [])

  return (
    <ExamplesContainer ref={containerRef}>
      {resumeExamples.map(example => (
        <ResumeCard
          key={example.id}
          onClick={() => {
            trackInternalEvent(UseExampleEvents.clickExample, {
              label: UseExampleEventLabels.examplesPrefill,
              jobTitle: example.jobTitle,
            })
            setSelectedResumeExample(example)
          }}
        >
          <ResumeTitle>{example.jobTitle}</ResumeTitle>
          <ResumeImg
            src={example.compressedPreviewImageUrl || example.previewImageUrl}
            rootRef={containerRef}
            placeholderSrc={cardPlaceholder}
          />
          <ViewIcon src={view} alt="View resume example" />
        </ResumeCard>
      ))}
      {fetchingResumeExamples && (
        <LoaderContainer $isFirstLoading={currentPage === 0}>
          <Spinner />
        </LoaderContainer>
      )}
    </ExamplesContainer>
  )
}

export default ResumeExamples
